import React from "react";
import { Row, Col, Table } from "react-bootstrap";
import CountUp from "react-countup";

const DATA = [
  { label: "Rent per month", value: 2300, prefix: "$" },
  { label: "Real estate Taxes", value: 400, prefix: "$" },
  { label: "Insurance", value: 46, prefix: "$" },
  { label: "HOA", value: 49, prefix: "$" },
  { label: "Management and Maintenance", value: 149, prefix: "$" },
  { label: "Total Expenses", value: 644, prefix: "$" },
  { label: "Net Operating Income / Month", value: 1656, prefix: "$" },
  { label: "Mortgage (240K @ 6.25%)", value: 1062, prefix: "$" },
  { label: "Cash Flow / Month", value: 594, prefix: "$" },
];

const RentalProforma = () => {
  return (
    <section
      className="min-h-screen flex items-center justify-center px-4 bg-transparent"
      id="proforma"
    >
      <div className="container mx-auto w-full max-w-4xl">
        {/* Title */}
        <Row>
          <Col md={12}>
            <div className="section-title-box text-center mb-10">
              <h1 className="section-title">
                Rental<span className="text-primary"> Proforma</span>
                <div className="title-line before-line" />
                <div className="title-line after-line" />
              </h1>
            </div>
          </Col>
        </Row>

        {/* Centered & Responsive Table */}
        <div className="flex justify-center items-center">
          <div
            className="rounded-2xl overflow-hidden w-full max-w-lg"
            style={{
              border: "1px solid rgba(255,255,255,0.15)",
              boxShadow: "0 8px 25px rgba(59, 201, 219, 0.3)",
              background: "rgba(255, 255, 255, 0.05)",
              backdropFilter: "blur(12px)",
            }}
          >
            <Table
              bordered
              hover
              responsive
              className="mb-0 text-center align-middle"
              style={{ margin: 0 }}
            >
              <tbody>
                {DATA.map((row, idx) => {
                  // Insert a spacer row before the last 3 rows
                  const isGapRow = idx === DATA.length - 3;
                  return (
                    <React.Fragment key={idx}>
                      {isGapRow && (
                        <tr>
                          <td colSpan={2} style={{ height: "24px", border: "none" }} />
                        </tr>
                      )}
                      <tr>
                        <td
                          style={{
                            padding: "14px 18px",
                            fontWeight: idx === DATA.length - 1 ? "600" : "400",
                            color: idx === DATA.length - 1 ? "#3bc9db" : "white",
                            textAlign: "center",
                            verticalAlign: "middle",
                            border: "1px solid rgba(255,255,255,0.12)",
                            background:
                              idx === DATA.length - 1
                                ? "rgba(59,201,219,0.08)"
                                : "transparent",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {row.label}
                        </td>
                        <td
                          style={{
                            padding: "14px 18px",
                            fontWeight: idx === DATA.length - 1 ? "600" : "400",
                            color: idx === DATA.length - 1 ? "#3bc9db" : "white",
                            textAlign: "center",
                            verticalAlign: "middle",
                            border: "1px solid rgba(255,255,255,0.12)",
                            background:
                              idx === DATA.length - 1
                                ? "rgba(59,201,219,0.08)"
                                : "transparent",
                          }}
                        >
                          <CountUp
                            end={row.value}
                            duration={3.5}
                            separator=","
                            prefix={row.prefix}
                          />
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RentalProforma;
